const isNotEmptyArray = value => Array.isArray(value) && value.length;

export {
    isNotEmptyArray
};
